var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('single-panel-page',[_c('RedirectAlert'),_vm._v(" "),_c('login-form',{attrs:{"next":_vm.next}},[_c('span',{attrs:{"slot":"footer"},slot:"footer"})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }